/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {FormatMomentDatePipe as ɵa} from './pipes/format-moment-date.pipe';